<form [formGroup]="supplierCreditNoteFeeForm" id="supplierCreditNoteFeeForm" (ngSubmit)="onSubmit()">
  <div class="grid">
    <div class="card g-col-12">
      <div class="card-body grid">
        <div class="d-flex flex-column g-col-12 g-col-lg-6">
          <kendo-formfield showHints="initial" showErrors="initial">
            <kendo-label
              labelCssClass="k-form-label"
              [for]="documentFeeType"
              [text]="'DOCUMENT_FEE' | translate | capitalize"></kendo-label>
            @let documentFees = documentFeeTypes$ | async;
            <kendo-combobox
              rcValidation
              #documentFeeType
              [data]="getData(documentFees)"
              [filterable]="true"
              (filterChange)="onSearch($event)"
              [kendoDropDownFilter]="filterSettings"
              [textField]="'name'"
              [valueField]="'@id'"
              [valuePrimitive]="true"
              formControlName="type" />
          </kendo-formfield>
        </div>
        <div class="d-flex flex-column g-col-12 g-col-lg-6">
          <kendo-formfield showHints="initial" showErrors="initial">
            <kendo-label
              labelCssClass="k-form-label"
              [for]="amount"
              [text]="'AMOUNT' | translate | capitalize"></kendo-label>
            <kendo-numerictextbox
              rcValidation
              #amount
              [format]="decimalFormat"
              [spinners]="false"
              [changeValueOnScroll]="false"
              formControlName="amount" />
          </kendo-formfield>
        </div>
      </div>
    </div>
  </div>
</form>
<kendo-dialog-actions>
  <div class="d-flex justify-content-end gap-16">
    <button kendoButton class="g-start-10 string-button" (click)="close()">
      {{ "CANCEL" | translate | capitalize }}
    </button>
    <button
      [disabled]="supplierCreditNoteFeeForm.invalid"
      class="g-col-2 g-start-11"
      kendoButton
      type="submit"
      form="supplierCreditNoteFeeForm"
      [iconClass]="'rc-icon-plus'"
      [themeColor]="'primary'">
      {{ "CREATE" | translate | capitalize }}
    </button>
  </div>
</kendo-dialog-actions>
